module.exports = __webpack_public_path__ + "static/intelerad-8444dd04743b856a70c524ae8a5a4725.svg";